import { render, staticRenderFns } from "./new-invoice.vue?vue&type=template&id=c3c2a594"
import script from "./new-invoice.vue?vue&type=script&lang=js"
export * from "./new-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports